module.exports = __webpack_public_path__ + "img/comprobantes.5de191d0.png";